import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class WeatherForecastService {

  private baseUrl = 'https://api.openweathermap.org/data/2.5/weather';
  public WeatherType = [
    { name: 'Thunderstorm', img: 'assets/img/thunderstorm.png'},
    { name: 'Drizzle', img: 'assets/img/rain.png'},
    { name: 'Rain', img: 'assets/img/rain.png'},
    { name: 'Clear', img: 'assets/img/sunny.png'},
    { name: 'Clouds', img: 'assets/img/cloudy.png'},
  ]
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService) {
  }

  getWeatherForecast(latitude, longitude) {
    return this.http.get<any>(`${this.baseUrl}?lat=${latitude}&lon=${longitude}&appid=${this.appConfigService.OpenWeatherApiKey}&units=metric`);
  }
}
